import Layout from 'layout';
import PrequalificationReviewFormCreate from 'features/PrequalificationReview/pages/Create';
import { LayoutProvider } from '../layout/context/layoutcontext';

function PrequalificationReviewFormCreatePage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
        }}
      >
        <PrequalificationReviewFormCreate />
      </Layout>
    </LayoutProvider>
  );
}

export default PrequalificationReviewFormCreatePage;
